<div class="container-scroller">
  <ng-container *ngIf="screenSize === 'desktop'">
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper auth">
        <div class="auth-form desktop">
          <div class="brand-logo">
            <img src="assets/img/OpStoom_logo_30-jaar.svg" alt="Logo" />
          </div>
          <h4 class="title">{{ "welcomeMessage" | translate }}</h4>
          <h6 class="subtitle fw-light">{{ "login.subtitle" | translate }}</h6>

          <form [formGroup]="loginForm">
            <div class="form-group">
              <input
                id="username"
                formControlName="username"
                class="form-control"
                placeholder="{{ 'login.username' | translate }}"
              />
              <messages
                class="msg"
                [form]="loginForm"
                [messagesObserver]="messages"
                fieldname="username"
              ></messages>
            </div>
            <div class="form-group">
              <input
                id="password"
                type="password"
                formControlName="password"
                class="form-control"
                placeholder="{{ 'login.password' | translate }}"
              />
            </div>
            <messages
              class="msg"
              [form]="loginForm"
              [messagesObserver]="messages"
              fieldname="password"
            ></messages>

            <a
              class="forgot-password-link"
              (click)="navigateToForgotPassword()"
            >
              {{ "login.forgotPassword" | translate }}
            </a>

            <div class="button-container">
              <action-button
                (actionEvent)="onSignIn($event)"
                label="{{ buttonLabel | translate }}"
                class="btn"
              ></action-button>
            </div>
            <messages
              class="message"
              [form]="loginForm"
              [messagesObserver]="messages"
              [showNonFieldKeys]="TRUE"
              [showFieldName]="TRUE"
              [showFieldKeys]="FALSE"
            ></messages>
          </form>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="screenSize === 'tablet'">
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper auth">
        <div class="auth-form tablet">
          <div class="brand-logo">
            <img src="assets/img/OpStoom_logo_30-jaar.svg" alt="Logo" />
          </div>
          <h4 class="title">{{ "welcomeMessage" | translate }}</h4>
          <h6 class="subtitle fw-light">{{ "login.subtitle" | translate }}</h6>

          <form [formGroup]="loginForm">
            <div class="form-group">
              <input
                id="username"
                formControlName="username"
                class="form-control"
                placeholder="{{ 'login.username' | translate }}"
              />
              <messages
                class="msg"
                [form]="loginForm"
                [messagesObserver]="messages"
                fieldname="username"
              ></messages>
            </div>
            <div class="form-group">
              <input
                id="password"
                type="password"
                formControlName="password"
                class="form-control"
                placeholder="{{ 'login.password' | translate }}"
              />
            </div>
            <messages
              class="msg"
              [form]="loginForm"
              [messagesObserver]="messages"
              fieldname="password"
            ></messages>

            <a
              class="forgot-password-link"
              (click)="navigateToForgotPassword()"
            >
              {{ "login.forgotPassword" | translate }}
            </a>

            <div class="button-container">
              <action-button
                (actionEvent)="onSignIn($event)"
                label="{{ buttonLabel | translate }}"
                class="btn"
              ></action-button>
            </div>
            <messages
              class="message"
              [form]="loginForm"
              [messagesObserver]="messages"
              [showNonFieldKeys]="TRUE"
              [showFieldName]="TRUE"
              [showFieldKeys]="FALSE"
            ></messages>
          </form>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="screenSize === 'mobile'">
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper auth">
        <div class="auth-form mobile">
          <div class="brand-logo">
            <img src="assets/img/OpStoom_logo_30-jaar.svg" alt="Logo" />
          </div>
          <h4 class="title">{{ "welcomeMessage" | translate }}</h4>
          <h6 class="subtitle fw-light">{{ "login.subtitle" | translate }}</h6>

          <form [formGroup]="loginForm">
            <div class="form-group">
              <input
                id="username"
                formControlName="username"
                class="form-control"
                placeholder="{{ 'login.username' | translate }}"
              />
              <messages
                class="msg"
                [form]="loginForm"
                [messagesObserver]="messages"
                fieldname="username"
              ></messages>
            </div>
            <div class="form-group">
              <input
                id="password"
                type="password"
                formControlName="password"
                class="form-control"
                placeholder="{{ 'login.password' | translate }}"
              />
              <messages
                class="msg"
                [form]="loginForm"
                [messagesObserver]="messages"
                fieldname="password"
              ></messages>
            </div>

            <messages
              class="message"
              [form]="loginForm"
              [messagesObserver]="messages"
              [showNonFieldKeys]="TRUE"
              [showFieldName]="TRUE"
              [showFieldKeys]="FALSE"
            ></messages>

            <a
              class="forgot-password-link"
              (click)="navigateToForgotPassword()"
            >
              {{ "login.forgotPassword" | translate }}
            </a>

            <div class="button-container">
              <action-button
                (actionEvent)="onSignIn($event)"
                label="{{ buttonLabel | translate }}"
                class="btn"
              ></action-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </ng-container>
</div>
